import { Route } from "@angular/router";

export const WidgetsPaths = {
  Overview: "overzicht",
  EditTexts: "teksten/bewerken",
  Edit: (widgetId: number | string) => `bewerken/${widgetId}`,
};

export default [
  {
    path: WidgetsPaths.Overview,
    loadComponent: () =>
      import("./pages/search-widget/search-widget.component").then((c) => c.SearchWidgetComponent),
    data: {
      breadcrumb: "Overzicht",
      title: "Widgets",
    },
  },
  {
    path: "search",
    redirectTo: WidgetsPaths.Overview,
  },
  {
    path: WidgetsPaths.EditTexts,
    loadComponent: () =>
      import("./pages/text-widget-edit/text-widget-edit.component").then(
        (c) => c.TextWidgetEditComponent
      ),
    data: {
      breadcrumb: "Widget teksten aanpassen",
      title: "Widget teksten aanpassen",
    },
  },
  {
    path: WidgetsPaths.Edit(":id"),
    loadComponent: () =>
      import("./pages/widget-edit/widget-edit.component").then((c) => c.WidgetEditComponent),
    data: {
      breadcrumb: "Widget toevoegen",
      title: "Widget toevoegen",
    },
  },
] satisfies Route[];
